import { Route, Routes } from "react-router-dom";
import JaktdagDetaljer from "./JaktdagDetaljer";
import Oversikt from "./Oversikt";
import SkuttDyrDetaljer from "./SkuttDyrDetaljer";

export default function OversiktLayout({
  setHeader,
}: {
  setHeader: (e: string) => void;
}): JSX.Element {
  return (
    <Routes>
      <Route index element={<Oversikt />} />
      <Route
        path="skuttdyrdetaljer/:art/:individId"
        element={<SkuttDyrDetaljer setHeader={setHeader} />}
      />
      <Route
        path="jaktdagdetaljer/:jaktdagId"
        element={<JaktdagDetaljer setHeader={setHeader} />}
      />
    </Routes>
  );
}
